// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1xsOh","savePackageButton":"ClientWallet_savePackageButton__vf6Lv"};